import Vue from 'vue'; 
import VueI18n from 'vue-i18n'; 
import tr from '@/lang/tr'
import en from '@/lang/en'

Vue.use(VueI18n);

// format text in here so that you won't need to format it in html
const messages = { 
    tr,
    en
};

const locale = 'tr'

export default new VueI18n({ 
    locale, // set locale    
    fallbackLocale: 'tr', // set fallback locale    
    messages, // set locale messages
})
